import { Pipe, PipeTransform } from '@angular/core';
import { formatUtcDate } from '../shared/date-utils';

/**
 * Formats a date/string as US-notation time locked to UTC — identical for all users.
 *
 * Usage:
 *   {{ someDate | utcDate }}           → 04/23/2026, 3:00:00 AM
 *   {{ someDate | utcDate:'date' }}    → 04/23/2026
 *   {{ someDate | utcDate:'time' }}    → 3:00:00 AM
 *   {{ someDate | utcDate:'short' }}   → 04/23/2026, 3:00 AM
 */
@Pipe({
  name: 'utcDate',
  standalone: true,
})
export class UtcDatePipe implements PipeTransform {
  transform(value: string | Date | null | undefined, format: 'full' | 'date' | 'time' | 'short' = 'full'): string {
    if (!value) {
      return 'N/A';
    }
    const d = typeof value === 'string' ? new Date(value) : value;
    if (isNaN(d.getTime())) {
      return 'Invalid date';
    }
    return formatUtcDate(d, format);
  }
}

